import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  message: null,
  error: null,
  data: [],
};

const getTravelPlanDetailSlice = createSlice({
  name: "getTravelPlanDetail",
  initialState,
  reducers: {
    getTravelPlanDetailStart(state, payload) {
      state.loading = true;
      state.error = null;
      state.message = null;
    },

    getTravelPlanDetailSuccess(state, action) {
      state.loading = false;
      const flattenedArray = []?.concat(...action?.payload);
      state.data = flattenedArray;
      state.message = action.payload.message;
    },
    getTravelPlanDetailFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.message = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
});

export const {
  getTravelPlanDetailStart,
  getTravelPlanDetailSuccess,
  getTravelPlanDetailFailure,
  clearError,
  clearMessage,
} = getTravelPlanDetailSlice.actions;

export default getTravelPlanDetailSlice.reducer;
